<div class="menu">
    <div class="dropdown">
        <div>
            <button title="More Options" type="button" class="dropbtn">
                <div class="dot-wrapper">
                    <div class="position-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </button>
            <div class="dropdown-content">
                <ng-container *ngFor="let option of optionsToShow">
                    <div id="{{option.title + '-' + recId}}">
                        <a (click)=onClick(option.title)>{{option.title}}</a>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<div class="cover-all" *ngIf="displayCover">
    <ng-container *ngIf="popUpFor=='dismiss'">
        <app-dismiss-form [recName]="recName" (submit)="submitForm($event)">
        </app-dismiss-form>
    </ng-container>
    <ng-container *ngIf="popUpFor=='snooze'">
        <app-snooze-form [recName]="recName" (submit)="submitForm($event)">
        </app-snooze-form>
    </ng-container>
</div>